import { Link } from 'gatsby'
import { useMobile } from 'src/hooks/useMobile'
import { getStandardObject } from 'src/utils/amplitude/getStandardObject'
import { getFeatureObject } from 'src/utils/amplitude/getFeatureObject'
import { dispatchAmplitudeEvent } from 'src/utils/amplitude'
import { useGlobalContext } from 'src/components/contexts/GlobalContext'

import {
  getImageWithCertainResolution,
  insertClassNameAccordingToDeviceAndImageOptions,
  renderImagemFullBackgroundOrNo,
} from './helpers'
import type { CarroselDataCMS } from '.'

export default function InfoBannerItem({
  infobanner: { carroselConfig, carroselContent },
  index,
  title,
  section,
  locationOnPage,
}: {
  infobanner: CarroselDataCMS
  index: number
  title: string
  section?: string
  locationOnPage?: string
}) {
  const { screenWidth } = useMobile()
  const { pageData } = useGlobalContext()
  const background =
    carroselConfig?.backgroundFullImage && !carroselContent?.enableImage
      ? {
          backgroundImage: `url(${carroselContent?.imageDesktop})`,
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
        }
      : { backgroundColor: carroselConfig?.backgroundColorImage }

  const standardObject = getStandardObject(pageData)

  const sendAmplitudeClickEvent = () => {
    if (!section || !locationOnPage) {
      return
    }

    const featureObject = getFeatureObject({
      section,
      locationOnPage,
      name:
        title ?? carroselContent?.title ?? carroselContent?.description ?? '',
      index,
    })

    dispatchAmplitudeEvent({
      eventName: 'Promotional Element Selected',
      eventData: {
        ...standardObject,
        ...featureObject,
      },
    })
  }

  return (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    <div
      key={index}
      onClick={() => sendAmplitudeClickEvent()}
      onKeyDown={() => sendAmplitudeClickEvent()}
    >
      <Link
        to={carroselConfig?.link}
        className="infobanner-item"
        style={{
          height: getImageWithCertainResolution({
            screenWidth,
            carroselContent,
          })?.height,
          ...background,
        }}
      >
        {!carroselContent?.enableImage ? (
          <div />
        ) : (
          <div
            className="container-imageInfoBanner"
            style={!carroselContent?.enableText ? { height: '100%' } : {}}
          >
            <img
              {...getImageWithCertainResolution({
                screenWidth,
                carroselContent,
              }).image}
              alt={carroselContent?.title}
            />
          </div>
        )}
        {!carroselContent?.enableText ? (
          <div />
        ) : (
          <div
            className="container-textInfobanner"
            style={{
              // backgroundColor: carroselConfig?.backgroundColorText,
              ...renderImagemFullBackgroundOrNo({
                carroselContent,
                carroselConfig,
              }),
            }}
          >
            <h2
              className={insertClassNameAccordingToDeviceAndImageOptions({
                carroselContent,
                carroselConfig,
              })}
              style={{ color: carroselConfig?.fontColorTitle }}
            >
              {carroselContent?.title}
            </h2>
            <p
              className={insertClassNameAccordingToDeviceAndImageOptions({
                carroselContent,
                carroselConfig,
              })}
              style={{ color: carroselConfig?.fontColorDescription }}
            >
              {carroselContent?.description}
            </p>
          </div>
        )}
      </Link>
    </div>
  )
}
